<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/FinancialServices/IDTs">
              Facilities
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/FinancialServices/Assets">Computer Assets</b-breadcrumb-item>
            <b-breadcrumb-item active>Add</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Create New Computer Asset</div>
                <div class="card-body">
                    <div>
                        <fieldset class="border p-3 mr-2">
                            <legend class="w-auto h5">
                                <span>Asset Details</span>
                            </legend>
                            
                            <div class="row">
                                <div class="col-lg-3 col-md-4 form-group">
                                <label for="assetNumber">Asset Number</label>
                                <input class="form-control"
                                        v-model="newComputerAsset.assetNumber"/>
                            </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-lg-3 col-md-4 form-group">
                                    <label for="manufacturer">Manufacturer</label>
                                    <input class="form-control"
                                            v-model="newComputerAsset.manufacturer"/>
                                </div>
                                <div class="col-lg-3 col-md-4 form-group">
                                    <label for="modelNumber">Model Number</label>
                                    <input class="form-control"
                                            v-model="newComputerAsset.modelNumber"/>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-3 col-md-4 form-group">
                                    <label for="serialNumber">Serial Number</label>
                                    <input class="form-control"
                                            v-model="newComputerAsset.serialNumber"/>
                                </div>
                                <div class="col form-group">
                                    <label for="description">Description</label>
                                    <input class="form-control"
                                            v-model="newComputerAsset.description"/>
                                </div>
                            </div>
                        </fieldset>
                         <br>
                    </div>

                    <div>

                        <fieldset class="border p-3 mr-2">
                            <legend class="w-auto h5">
                                <span>Purchase Details</span>
                            </legend>

                            <div class="row">
                                <div class="col form-group">
                                    <label for="vendor">Vendor</label>
                                    <input class="form-control"
                                            v-model="newComputerAsset.vendor"/>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-2 form-group">
                                    <label for="purchaseAmount">Purchase Amount</label>
                                    <input class="form-control"
                                            v-model="newComputerAsset.purchaseAmount"/>
                                </div>
                                <div class="col-md-3 form-group">
                                    <label for="purchaseDate">Purchase Date</label>
                                    <b-input-group class="mb-3">
                                    <b-form-input
                                        v-model="tempPurchaseDate"
                                        type="text"
                                        placeholder="MM/DD/YYYY"
                                        autocomplete="off"
                                        @change="updatePurchaseDateFromInput()"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker
                                        id="purchaseDate"
                                        v-model="newComputerAsset.purchaseDate"
                                        button-only
                                        right
                                        locale="en-US"
                                        aria-controls="purchaseDate"
                                        @context="updatePurchaseDateFromButton()"
                                        ></b-form-datepicker>
                                    </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </div>
                        </fieldset>
                         <br>
                    </div>

                    <div>

                        <fieldset class="border p-3 mr-2">
                            <legend class="w-auto h5">
                                <span>Assignment Details</span>
                            </legend>
                            <div class="row">
                                <div class="col-md-4 form-group">
                                    <label for="custodianPersonId">Custodian</label>
                                    <select class="form-control" v-model="newComputerAsset.custodianPersonId">
                                        <option :value="null" disabled>--Select Person--</option>
                                        <option :key="custodian.id" :value="custodian.id" v-for="custodian in custodians">{{custodian.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-3 form-group">
                                    <label for="organization">Organization</label>
                                    <div class="text-center">{{ custodianDepartment }}</div>
                                </div>
                            </div>
                        </fieldset>
                         <br>
                    </div>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'ComputerAssets'}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import {required} from "vuelidate/lib/validators";
    import ComputersService from "@/services/ComputersService";
    import PersonService from "@/services/PersonService";

    export default {
        props: {
            assetNumber: {
                default: null,
                required: false,
                type: String
            }
        },
        data() {
            return {
                custodians: [],
                isSubmitting: false,
                isValidating: false,
                newComputerAsset: {
                  assetNumber: this.assetNumber,
                  serialNumber: null,
                  manufacturer: null,
                  modelNumber: null,
                  description: null,
                  vendor: null,
                  custodianPersonId: null,
                  purchaseAmount: null,
                  purchaseDate: null,
                  createdByPersonId: this.$store.getters.user.id
                },
                tempPurchaseDate: null
            }
        },
        computed: {
            custodianDepartment () {
              const vm = this;
              const custodian = this.custodians.find((val) => {
                return val.id === vm.newComputerAsset.custodianPersonId
              });
              
              if (custodian) {
                return custodian.organizationCode;
              }
              return "-";
            }
        },
        methods: {
            /**
             * @description Creates a computer asset and redirects if successful
             */
            onSubmit() {
                const vm = this;
                vm.isValidating = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;

                ComputersService.addComputerAsset(this.newComputerAsset)
                    .then(response => {
                      vm.alert(ToastType.Success, "The computer asset was successfully created");
                      vm.$router.replace({name:'ComputerAssets'})
                    })
                    .catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)
                    })
                    .finally(() => {
                      vm.isValidating = false;
                      vm.isSubmitting = false;
                    })
            },

            loadCustodians () {
              const vm = this;

              PersonService.getPeopleList({
                page: 1,
                pageSize: 10,
                name: null,
                uin: null,
                organizationCode: null,
                onlyShowActive: true,
                onlyShowTTI: true,
                onlyShowMissingAddress: false,
                returnAll: true
              })
                  .then(response => {
                      this.custodians = response.data;
                  })
                  .catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                  })
            },

            updatePurchaseDateFromInput () {
                if (this.tempPurchaseDate !== null) {
                  this.newComputerAsset.purchaseDate = this.$moment(this.tempPurchaseDate, "MM/DD/YYYY").toDate()
                }
            },

            updatePurchaseDateFromButton () {
                if (this.newComputerAsset.purchaseDate !== null) {
                  this.tempPurchaseDate = this.$moment(this.newComputerAsset.purchaseDate).format("MM/DD/YYYY")
                }
            }
        },
        validations: {
            newComputerAsset: {
              assetNumber: {
                required
              }
            }
        },
        created () {
          this.loadCustodians()

          
        }
    }
</script>
